import React from "react";
import { Fragment } from "react";
//import { LayoutClient } from "../layouts";

import Login from "../modules/Login/Login";
import Logout from "../modules/Login/Logout";
import Register from "../modules/Login/Register";
/////////////admin/////////////////////////

const Dashboard = React.lazy(() => import("../modules/Dashboard/Dashboard"));
const Menu = React.lazy(() => import("../modules/Menu"));
const Module_Permission = React.lazy(() => import("../modules/Module_Permission"));
const Function_Permission = React.lazy(() => import("../modules/Function_Permission"));
const Role = React.lazy(() => import("../modules/Role"));
const Staff = React.lazy(() => import("../modules/Staff"));
const DiaryPersonal = React.lazy(() => import("../modules/DiaryPersonal"));
const User = React.lazy(() => import("../modules/User"));
const ReportAccount = React.lazy(() => import("../modules/ReportAccount"));
//const Product = React.lazy(() => import("../modules/Product"));
//const ProductCate = React.lazy(() => import("../modules/ProductCate"));
const Organize = React.lazy(() => import("../modules/Organize"));
const OrganizeInfo = React.lazy(() => import("../modules/OrganizeInfo"));
const CalendarWork = React.lazy(() => import("../modules/CalendarWork"));
/////////////danh muc////
const CateNationality = React.lazy(() => import("../modules/CateNationality"));
const CateReligion = React.lazy(() => import("../modules/CateReligion"));
const CateOrganize = React.lazy(() => import("../modules/CateOrganize"));
const CateEthnic = React.lazy(() => import("../modules/CateEthnic"));
const CatePositionUnion = React.lazy(() => import("../modules/CatePositionUnion"));
const CatePositionParty = React.lazy(() => import("../modules/CatePositionParty"));
const CatePositionTradeUnion = React.lazy(() => import("../modules/CatePositionTradeUnion"));
const CateLanguageCertificate = React.lazy(() => import("../modules/CateLanguageCertificate"));
const CateInformaticsCertificate = React.lazy(() => import("../modules/CateInformaticsCertificate"));
const CateFormsTraining = React.lazy(() => import("../modules/CateFormsTraining"));
const CateLog = React.lazy(() => import("../modules/CateLog"));
////////////////////phan mem quan ly quang cao///////////////////////////////////////////
////////////////////danh muc//////////////////////////////////////
const CateAd = React.lazy(() => import("../modules/ADVCateAd"));
const CateChannel = React.lazy(() => import("../modules/ADVCateChannel"));
const CateProduct = React.lazy(() => import("../modules/ADVCateProduct"));
const CateCustomer = React.lazy(() => import("../modules/ADVCateCustomer"));
const CateRecipe = React.lazy(() => import("../modules/ADVCateRecipe"));
const CateState = React.lazy(() => import("../modules/ADVCateState"));
const CateStatusProduct = React.lazy(() => import("../modules/ADVCateStatusProduct"));
const Customer = React.lazy(() => import("../modules/ADVCustomer"));
const Price = React.lazy(() => import("../modules/ADVPrice"));
const AdAllowYear = React.lazy(() => import("../modules/ADVAdAllowYear"));
const Program = React.lazy(() => import("../modules/ADVProgram"));
const Product = React.lazy(() => import("../modules/ADVProduct"));
const Contract = React.lazy(() => import("../modules/ADVContract"));
const CalendarAd = React.lazy(() => import("../modules/ADVCalendarAd"));
const BroadcastSchedule = React.lazy(() => import("../modules/ADVBroadcastSchedule"));
const BroadcastCertification = React.lazy(() => import("../modules/ADVBroadcastCertification"));
const Report = React.lazy(() => import("../modules/ADVReport"));
const Debt = React.lazy(() => import("../modules/ADVDebt"));
////////////////////phan mem quan ly Báo///////////////////////////////////////////
const news_price = React.lazy(() => import("../modules/news_price"));
const news_print = React.lazy(() => import("../modules/news_print"));
const news_contract = React.lazy(() => import("../modules/news_contract"));
const news_client = React.lazy(() => import("../modules/news_client"));
const news_configuration = React.lazy(() => import("../modules/news_configuration"));
const news_ele = React.lazy(() => import("../modules/news_ele"));
///////////////////Phát hành - tuyên truyền///////////////////////
const rel_client = React.lazy(() => import("../modules/rel_client"));
const rel_contract = React.lazy(() => import("../modules/rel_contract"));
const rel_inve = React.lazy(() => import("../modules/rel_inve"));
const rel_price = React.lazy(() => import("../modules/rel_price"));
//////////////////Báo in////////////////////
const pri_unit = React.lazy(() => import("../modules/pri_unit"));
const pri_pri = React.lazy(() => import("../modules/pri_pri"));
const pri_sta = React.lazy(() => import("../modules/pri_sta"));
///////////////////////////////////////////////////////////
const relatv_client = React.lazy(() => import("../modules/relatv_client"));
const relatv_contract = React.lazy(() => import("../modules/relatv_contract"));
const relatv_price = React.lazy(() => import("../modules/relatv_price"))
const relatv_inve = React.lazy(() => import("../modules/relatv_inve"));

const publicRouters = [
    /// Fragment = null layout
    { path: "/login", component: Login, layout: Fragment },
];
const privateRouters = [
    ///default layout = LayoutAdmin
    { path: "/", component: Dashboard },
    { path: "/register", component: Register },
    { path: "/logout", component: Logout },
    { path: "/role", component: Role },
    { path: "/staff", component: Staff },
    { path: "/diary_personal", component: DiaryPersonal },
    { path: "/user", component: User },
    { path: "/report_account", component: ReportAccount },
    { path: "/menu", component: Menu },
    { path: "/module_permission", component: Module_Permission },
    { path: "/function_permission", component: Function_Permission },
    //{ path: "/product", component: Product },
    //{ path: "/product_cate", component: ProductCate },
    { path: "/organize", component: Organize },
    { path: "/organize_info", component: OrganizeInfo },
    { path: "/calendar_work", component: CalendarWork },
    { path: "/nationality_cate", component: CateNationality },
    { path: "/religion_cate", component: CateReligion },
    { path: "/organize_cate", component: CateOrganize },
    { path: "/ethnic_cate", component: CateEthnic },
    { path: "/position_union_cate", component: CatePositionUnion },
    { path: "/position_party_cate", component: CatePositionParty },
    { path: "/position_trade_union_cate", component: CatePositionTradeUnion },
    { path: "/language_certificate_cate", component: CateLanguageCertificate },
    { path: "/informatics_certificate_cate", component: CateInformaticsCertificate },
    { path: "/forms_training_cate", component: CateFormsTraining },
    { path: "/log_cate", component: CateLog },
    ////////////////////////////////////////
    { path: "/ad_cate", component: CateAd },
    { path: "/channel_cate", component: CateChannel },
    { path: "/product_cate", component: CateProduct },
	{ path: "/customer_cate", component: CateCustomer },
	{ path: "/recipe_cate", component: CateRecipe },
	{ path: "/state_cate", component: CateState },
	{ path: "/status_product_cate", component: CateStatusProduct },
	{ path: "/customer", component: Customer },
	{ path: "/price", component: Price },
	{ path: "/ad_allow_year", component: AdAllowYear },
	{ path: "/program", component: Program },
	{ path: "/product", component: Product },
	{ path: "/contract", component: Contract },
	{ path: "/calendar_ad", component: CalendarAd },
    { path: "/broadcast_schedule", component: BroadcastSchedule },
    { path: "/broadcast_certification", component: BroadcastCertification },
    { path: "/report", component: Report },
    { path: "/debt", component: Debt },
    //////////////////////////////////
    { path: "/news_price", component: news_price },
    { path: "/news_print", component: news_print },
    { path: "/news_contract", component: news_contract },
    { path: "/news_client", component: news_client },
    { path: "/news_configuration", component: news_configuration },
    { path: "/news_ele", component: news_ele },
    //////////////////////////////////
    { path: "/rel_client", component: rel_client },
    { path: "/rel_contract", component: rel_contract },
    { path: "/rel_inve", component: rel_inve },
    { path: "/pri_unit", component: pri_unit },
    { path: "/pri_pri", component: pri_pri },
    { path: "/pri_sta", component: pri_sta },
    { path: "/rel_price", component: rel_price },
    /////////////////////////////////////////
    { path: "/relatv_client", component: relatv_client },
    { path: "/relatv_contract", component: relatv_contract },
    { path: "/relatv_price", component: relatv_price },
    { path: "/relatv_inve", component: relatv_inve },
    
];

export { publicRouters, privateRouters };
